namespace $ {
	/** Approximate DOM image, never a screen capture or a browser permission request. */
	export class $shm_hitalama_components_capture extends $mol_object {
		@ $mol_mem
		engine() { return $mol_import.script( 'shm/hitalama/lib/domimage/_index.js' ).htmlToImage as { toPng( node: HTMLElement, options: any ): Promise<string> } }
		async image( node: HTMLElement ) {
			const engine = await $mol_wire_async( this ).engine()
			await document.fonts.ready
			if( !node.isConnected ) throw new Error( 'Панель закрыта. Откройте приложение повторно.' )
			const nodes = [ node, ...node.querySelectorAll<HTMLElement>( '*' ) ]
			if( nodes.length > 4000 ) throw new Error( 'Слишком большой DOM для снимка. Выберите меньшую область.' )
			const warnings = [ 'Приблизительное изображение DOM, не настоящий скриншот экрана.' ]
			warnings.push( 'Внешние всплывающие элементы и пользовательские web-шрифты не включаются в снимок.' )
			if( node.querySelector( 'iframe' ) ) warnings.push( 'Содержимое iframe может отсутствовать или отображаться неверно.' )
			if( nodes.some( item => item.scrollTop || item.scrollLeft ) ) warnings.push( 'Прокрутка при клонировании DOM может сброситься. Позиции элементов из application_ui надёжнее изображения.' )
			if( node.querySelector( 'video, canvas' ) ) warnings.push( 'Видео и защищённый canvas могут отсутствовать.' )
			const rect = node.getBoundingClientRect()
			const width = Math.max( 1, Math.floor( rect.width ) ), height = Math.max( 1, Math.floor( rect.height ) )
			if( width * height > 2000000 ) throw new Error( 'Область снимка больше двух мегапикселей.' )
			const paint = document.createElement( 'canvas' ); paint.width = paint.height = 1
			const ctx = paint.getContext( '2d' )!, ancestors: HTMLElement[] = []
			for( let parent: HTMLElement | null = node; parent; parent = parent.parentElement ) ancestors.push( parent )
			ctx.fillStyle = 'white'; ctx.fillRect( 0, 0, 1, 1 )
			for( const parent of ancestors.reverse() ) { ctx.fillStyle = getComputedStyle( parent ).backgroundColor; ctx.fillRect( 0, 0, 1, 1 ) }
			const rgb = ctx.getImageData( 0, 0, 1, 1 ).data
			const started = performance.now()
			const controller = new AbortController, timer = setTimeout( ()=> controller.abort(), 8000 )
			let data: string
			try { data = await engine.toPng( node, { pixelRatio: 1, width, height, backgroundColor: `rgb(${ rgb[0] },${ rgb[1] },${ rgb[2] })`, style: { margin: '0', transform: 'none' }, skipFonts: true, fetchRequestInit: { signal: controller.signal } } ) }
			finally { clearTimeout( timer ) }
			const base64 = data.slice( data.indexOf( ',' ) + 1 )
			if( base64.length > 2800000 ) throw new Error( 'Снимок слишком большой для MCP.' )
			return { image: { data: base64, mimeType: 'image/png' }, width, height, ms: Math.round( performance.now() - started ), approximate: true, warnings }
		}
	}
}
